import footer from "../partials/footer.hbs";
document.body.insertAdjacentHTML("beforeend", footer());

